// prettier-ignore
export const FILE_NOT_PDF = "FILE_NOT_PDF"
export const FILE_NOT_FOUND = "FILE_NOT_FOUND"
export const GENERIC_ERROR = "GENERIC_ERROR"
export const BROWSER_ERROR = "BROWSER_ERROR"
export const CONNECTION_ERROR = "CONNECTION_ERROR"